import styled from 'styled-components';
import { TrimSelectStyled } from '../TrimSelectStyled';
import { rem } from 'polished';

export const TrimSelectStyledOV = styled(TrimSelectStyled)`
    .trim {
        border-color: ${({ theme }) => theme.colors.grey18};

        &.isSelected,
        &:hover,
        &:focus-visible {
            border-color: ${({ theme }) => theme.colors.black};
            .inner {
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .trimTitle {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        .icon {
            background: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
            .selected {
                background: ${({ theme }) => theme.colors.black};
                width: ${rem(8)};
                height: ${rem(8)};
                top: ${rem(7)};
                left: ${rem(7)};
            }
        }
    }
    
    .trimContent {
        font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
    }

    .isSelected {
        background: ${({ theme }) => theme.colors.grey10};
    }
`;
